





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import ButtonComponent from '@/shared/button/button.component.vue';

@Component({
  components: {
    ButtonComponent,
  },
})
export default class HomeMcpDetailsModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;

  private connectSteps: string[] = [
    'mcpDetailsConnectStep1',
    'mcpDetailsConnectStep2',
    'mcpDetailsConnectStep3',
    'mcpDetailsConnectStep4',
  ];

  private features: string[] = [
    'mcpDetailsFeature1',
    'mcpDetailsFeature2',
    'mcpDetailsFeature3',
    'mcpDetailsFeature4',
    'mcpDetailsFeature5',
    'mcpDetailsFeature6',
  ];

  private examples: string[] = [
    'mcpDetailsExample1',
    'mcpDetailsExample2',
    'mcpDetailsExample3',
    'mcpDetailsExample4',
    'mcpDetailsExample5',
    'mcpDetailsExample6',
  ];

  close() {
    this.$emit('close');
  }

  onDialogInput(value: boolean) {
    if (!value) {
      this.close();
    }
  }
}
